import React from 'react';
import { BenefitsType } from '@appTypes/benefitsType';
import { MembershipBenefitReference } from '@appTypes/membershipBenefitReferenceType';
import CardBenefitPartner from '@components/CardBenefitPartner/CardBenefitPartner';
import * as S from './Styles';

interface Props {
  benefitItems: Record<string, BenefitsType> | BenefitsType[] | MembershipBenefitReference[];
  matchedDepartment?: {
    slug: string;
  };
}

const BenefitsList = ({ benefitItems, matchedDepartment }: Props) => {
  const benefits = !(benefitItems instanceof Array) ? Object.values(benefitItems) : benefitItems;

  // If preview is true, it should not be listed but reachable with url.
  const visibleBenefits = benefits.filter((benefitItem) => !benefitItem.preview);
  const displayedBenefits = visibleBenefits.slice(0, 3);

  return (
    displayedBenefits && (
      <S.MobileBenefitListWrapper>
        <S.ScrollableWrapper>
          {displayedBenefits.map((benefitItem) => (
            <CardBenefitPartner
              isFlexible
              benefit={benefitItem}
              key={`s-${benefitItem.slug}`}
              matchedDepartment={matchedDepartment}
            />
          ))}
        </S.ScrollableWrapper>
      </S.MobileBenefitListWrapper>
    )
  );
};

export default BenefitsList;
